import React, { useState, useEffect, useCallback } from "react";
import GroupNavbar from "../../components/GroupNavbar";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import GroupManagement from "./GroupManagement";
import CustomToaster from "../../components/CustomToaster";

const index = ({ pageID, title }) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const toggle = () => setToggleBtn((val) => !val);
  const [navTitle, setnavTitle] = useState("Admin Console");
  const [NavbarCollapse, setNavbarCollapse] = useState(true);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [groupsCount, setGroupsCount] = useState(0);

  // Functions to communicate between navbar and GroupManagement
  const [groupSearchFunc, setGroupSearchFunc] = useState(null);
  const [createGroupFunc, setCreateGroupFunc] = useState(null);

  useEffect(() => {
    setnavTitle(title);
  }, [title]);

  const handleSendGroupsCount = (count) => {
    setGroupsCount(count);
  };

  const handleCloseButtonClick = () => {
    setToggleBtn(false);
  };

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  // Handle search data from navbar
  const handleGroupSearch = (searchTerm) => {
    if (groupSearchFunc) {
      groupSearchFunc(searchTerm);
    }
  };

  // Handle create group click from navbar
  const handleOpenGroupAdd = () => {
    if (createGroupFunc) {
      createGroupFunc();
    }
  };

  // Receive search function from GroupManagement
  const handleSearchDataReceived = useCallback((setSearchTermFunc) => {
    setGroupSearchFunc(() => setSearchTermFunc);
  }, []);

  // Receive create function from GroupManagement
  const handleCreateGroupClick = useCallback((openCreateModalFunc) => {
    setCreateGroupFunc(() => openCreateModalFunc);
  }, []);

  return (
    <div className="top-wrapper">
      <Sidebar
        toggleBtn={toggleBtn}
        onCloseButtonClick={handleCloseButtonClick}
        activeMenu="Admin Console"
      />
      <GroupNavbar
        setToggle={toggle}
        showGroupsCount={groupsCount}
        navTitle={navTitle}
        NavbarCollapse={NavbarCollapse}
        handleOpenGroupAdd={handleOpenGroupAdd}
        groupSearchData={handleGroupSearch}
      />
      <Content toggleBtn={toggleBtn}>
        <div className="dataconsole-responsvive-body">
          {toasterVisible && (
            <CustomToaster
              message={toasterMessage}
              duration={3000}
              onClose={closeToaster}
              position="right-top"
              appearance={toasterAppearance}
            />
          )}
          <GroupManagement
            showToaster={showToaster}
            userType={pageID}
            onSendGroupsCount={handleSendGroupsCount}
            onSearchDataReceived={handleSearchDataReceived}
            onCreateGroupClick={handleCreateGroupClick}
          />
        </div>
      </Content>
    </div>
  );
};

export default index;